import util from '@/util/public'

/* 商圈購物車公用函式 */

// cartData: {
//     updateTime: "1990-01-01 00:00:00",      //更新時間
//     itemList: [],        //購物車商品陣列，裝 item結構
//         item: {
//             localId: 0, //在前端暫存資料庫中的ID
//             id: 0,      //商品id
//             title:"" ,  //名稱
//             img:"",     //圖片
//             buyAmount: 0,  //購買數量
//             price: 0,     //金額(參考用)
//             storeId: item.storeId,          //店家ID
//             shopAreaId: item.shopAreaId,    //商圈ID
//             specIds: [],        //商品規格，金額可能會變動所以不記錄，內裝規格設定的ID
//         },
//     },
// }


export default {


    /** 產生新商品物件 */
    getBuyInfo: function (buyAmount, shopAreaId) {
        let buyInfo = {
                        buyAmount: buyAmount,       //購買量
                        storeId: 0,                 //店家ID
                        shopAreaId: shopAreaId,     //商圈ID
                    };
        return buyInfo;
    },

    /** 產生新商品物件(票券) */
    // newTicketInfo: function (item, ) {
    //     let ticketInfo = {
    //                           stageStartAt: "2024-03-26",
    //                           stageEndAt: "2024-03-26",
    //                           intervalType: 2,
    //                           stageStartTime: "09:00",
    //                           stageEndTime: "11:00",
    //                           buyNumber: 166,
    //                           couponListId: 171,
    //                           shopAreaCartId: 67,
    //                       };
    //     return ticketInfo;
    // },
    /** 產生新商品物件,
     * @item:商品的詳細資料，會隨api變動
     * @buyInfo: 購買的資訊，內容:
     *      {   buyAmount: 0,  //購買量
     *          storeId: 0,    //店家ID
     *          shopAreaId: 0, //商圈ID
     *      },
     * @ticketInfo: 票券的資訊(如果購買物是票券才有)，內容:
     *      {
     *          stageStartAt: "2024-03-26",
     *          stageEndAt: "2024-03-26",
     *          intervalType: 2,
     *          stageStartTime: "09:00",
     *          stageEndTime: "11:00",
     *          buyNumber: 166
     *          couponListId: 171,
     *          shopAreaCartId: 67,
     *      }
     * */
    newCartItemFull: function (item, buyInfo, ticketInfo = {}) {
        //移除不需要的資料
        let newItem = util.getObjectRemoveProp(item, ["dateList", "giftPack"]);

        //把新的欄位加到商品資料結構中
        return Object.assign({
            localId: 0,                 //前端記錄用的ID
            specIds: [],                //商品規格，金額可能會變動所以不記錄，內裝規格設定的ID，目前沒用
            updateTime: new Date().getTime(),
        }, buyInfo, ticketInfo, newItem);

        // return {
        //     id: 0,
        //     img: imgPath,
        //     name: name,
        //     itemId: itemId,             //商品id
        //     buyAmount: buyAmount,             //數量
        //     price: price,               //單價 = price
        //     storeId: storeId,           //店家ID
        //     shopAreaId: shopAreaId,     //商圈ID
        //     specIds: [],        //商品規格，金額可能會變動所以不記錄，內裝規格設定的ID
        //     coupon: [],
        //     giftPack: [],
        //
        //     updateTime: new Date().getTime(),
        // };
    },

    /** 以 localId尋找商品 */
    findItemById: function (localId) {
        let BreakException = {};
        let result = null;
        let cartItemList = this.getCart();
        if (util.notNull(cartItemList)) {
            try {
                cartItemList.forEach((element, index) => {
                    if (element.localId === localId) {
                        result = element;
                        throw BreakException;
                    }
                });
            } catch (e) {
                if (e !== BreakException) throw e;
            }
        }
        return result;
    },

    /** 以 商品id尋找商品 */
    findItemByItemId: function (itemId) {
        let BreakException = {};
        let result = null;
        let cartItemList = this.getCart();
        if (util.notNull(cartItemList)) {
            try {
                cartItemList.forEach((element, index) => {
                    if (element.id === itemId) {
                        result = element;
                        throw BreakException;
                    }
                });
            } catch (e) {
                if (e !== BreakException) throw e;
            }
        }
        return result;
    },

    /** 增加/減少數量 購物車 (給外部呼叫用) */
    addItemToCart: function (item) {
        let cartItemList = this.getCart();
        // console.log(`addItemToCard cartItemList:${JSON.stringify(cartItemList)}`);
        if (!util.notNull(cartItemList)) {
            //如果購物車陣列是空的，產生新陣列
            cartItemList = [];
        }
        this.addItemAmount(item, cartItemList);
        let maxLocalId = this.calMaxLocalID(cartItemList);
        this.saveToStorage(maxLocalId, -1, cartItemList);
    },

    /** 更新購物車中某個物品的資料 (給外部呼叫用) */
    updateCartItem: function (item) {
        let cartItemList = this.getCart();
        // console.log(`addItemToCard cartItemList:${JSON.stringify(cartItemList)}`);
        if ( !util.notNull(cartItemList) ) {
            //如果購物車陣列是空的，產生新陣列
            cartItemList = [];
        }
        this.updateItemAmount(item, cartItemList);
        this.saveCartToStorage(cartItemList);
    },

    /** 寫入目前商圈ID，商圈ID不可小於 0 */
    setShopAreaId: function (shopAreaId) {
        this.saveToStorage(-1, shopAreaId, null);
    },

    /** 取得目前商圈ID */
    getShopAreaId: function () {
        let result = 0;
        let data = this.getData();
        if (util.notNull(data)) {
            result = data.nowShopAreaId;
        }
        return result;
    },

    /** 取得購物車內所有商品的商圈ID是否相同，有一個不同則傳回 -1，相同則傳回商圈ID */
    checkCartItemsShopAreaId: function () {
        let result = 0;
        let BreakException = {};
        let cartItemList = this.getCart();
        if (util.notNull(cartItemList)) {
            try {
                cartItemList.forEach((element, index) => {
                    if (result === 0) {
                        result = element.shopAreaId;

                    } else if (element.shopAreaId !== result) {
                        result = -1;
                        throw BreakException;
                    }
                });
            } catch (e) {
                if (e !== BreakException) throw e;
            }
        }
        return result;
    },

    /** 判斷購物車內所有商品的商圈ID是否相同，有不同則傳回 false */
    isAllShopAreaIdSameInCart: function (shopAreaId) {
        let result = true;
        let BreakException = {};
        let cartItemList = this.getCart();
        if (util.notNull(cartItemList)) {
            try {
                cartItemList.forEach((element, index) => {
                    if (element.shopAreaId !== shopAreaId) {
                        result = false;
                        throw BreakException;
                    }
                });
            } catch (e) {
                if (e !== BreakException) throw e;
            }
        }
        return result;
    },

    /** 除了購物車內特定商圈的商品外，其他全部移除 */
    removeItemExceptShopAreaId: function (shopAreaId) {
        let result = [];
        let BreakException = {};
        let cartItemList = this.getCart();
        if (util.notNull(cartItemList)) {
            try {
                cartItemList.forEach((element, index) => {
                    if (element.shopAreaId === shopAreaId) {
                        result.tmz_load_push(element);
                    }
                });
            } catch (e) {
                if (e !== BreakException) throw e;
            }
        }
        this.saveCartToStorage(result);
        return result;
    },

    /** 寫入目前最大商品ID，ID不可小於 0 */
    setMaxLocalID: function (maxId) {
        this.saveToStorage(maxId, -1, null);
    },

    /** 取得最大 localID */
    getMaxLocalID: function () {
        let result = 0;
        let data = this.getData();
        if (util.notNull(data)) {
            result = data.nowId;
        }
        return result;
    },

    /** 清空購物車 */
    clearCart: function () {
        this.saveCartToStorage([]);
    },

    /** 取得購物車商品的種類數量 */
    getCartItemAmount: function () {
        let result = 0;
        let cartItemList = this.getCart();
        if (util.notNull(cartItemList)) {
            //如果購物車陣列是空的，產生新陣列
            result = Object.keys(cartItemList).length;
        }
        return result;
    },

    /** 計算陣列中商品的總價 */
    getTotalPrice: function (itemList) {
        let BreakException = {};
        let result = 0;
        if (util.notNull(itemList) && Object.keys(itemList).length > 0) {
            try {
                itemList.forEach((element) => {
                    result += (element.buyAmount * element.price);
                    throw BreakException;
                });
            } catch (e) {
                if (e !== BreakException) throw e;
            }
        }
        return result;
    },


// }
//
// default {

    /** 加入商品到itemList */
    addItem: function (itemList, item) {
        let destList = itemList;
        if (!util.notNull(destList)) {
            destList = [];
        }

        if (util.notNull(item)) {
            let nowTime = new Date().getTime();
            item["localId"] = this.calMaxLocalID(destList) + 1;
            item["updateTime"] = nowTime;
            destList.tmz_load_push(item);
        }
    },

    /** 增加/減少 itemList中某個商品的數量 */
    addItemAmount: function (item, itemList) {
        if (util.notNull(item) &&
            util.notNull(itemList)) {

            let index = this.isContain(itemList, item);
            if (index > -1) {
                //在陣列中有找到
                let itemInArray = itemList[index];
                itemInArray.buyAmount += item.buyAmount;
                itemInArray.updateTime = new Date().getTime();

                if (itemInArray.buyAmount <= 0) {
                    //如果數量已經變成負數，從陣列中移除
                    this.removeItem(itemList, item);
                }
            } else {
                //如果不存在陣列中，就加到陣列
                this.addItem(itemList, item);
            }
        }
    },


    /** 替換 itemList中的物品，如果ID不符就不替換 */
    updateItemById: function (item, itemList) {
        let BreakException = {};
        let result = -1;
        if (util.notNull(item) && util.notNull(itemList)) {
            try {
                Array.from(itemList).forEach((element, index) => {
                    if (element.id === item.id) {
                        itemList.splice(index, 1, item);
                        result = index;
                        throw BreakException;
                    }
                });
            } catch (e) {
                if (e !== BreakException) throw e;
            }
        }
        return result;
    },

    /** 更新數量 */
    updateItemAmount: function (item, itemList) {
        if (util.notNull(item) &&
            util.notNull(itemList)) {

            let index = this.isContain(itemList, item);
            if (index > -1) {
                //在陣列中有找到
                let itemInArray = itemList[index];
                itemInArray.buyAmount = item.buyAmount;
                itemInArray.updateTime = new Date().getTime();

                if (itemInArray.buyAmount <= 0) {
                    //如果數量已經變成負數，從陣列中移除
                    this.removeItem(itemList, item);
                }
            } else {
                //如果不存在陣列中，就加到陣列
                this.addItem(itemList, item);
            }
        }
    },

    /** 移除商品 */
    removeItem: function (itemList, item) {
        if (util.notNull(item) &&
            util.notNull(itemList)) {

            if (Object.keys(itemList).length > 0) {
                let index = this.isContain(itemList, item);
                if (index > -1) {
                    itemList.splice(index, 1); // 2nd parameter means remove one item only
                }
            }
        }
    },

    /** 算出最大 localID */
    calMaxLocalID: function (itemList) {
        let result = 0;
        if (util.notNull(itemList) && (Object.keys(itemList).length > 0)) {
            itemList.forEach((element, index) => {
                if (element.localId > result) {
                    result = element.localId;
                }
            });
        }
        return result;
    },




    /** 計算陣列中商品的總數量 */
    getItemBuyAmount: function (itemList) {
        let result = 0;
        if (util.notNull(itemList) && Object.keys(itemList).length > 0) {
            itemList.forEach((element) => {
                result += element.buyAmount;
            });
        }
        return result;
    },


    /** 陣列中是否包含某商品 */
    isContain: function (itemList, item) {
        let BreakException = {};
        let result = -1;
        if (util.notNull(item)) {
            if (util.notNull(itemList) && Object.keys(itemList).length > 0) {
                try {
                    itemList.forEach((element, index) => {
                        if (item.localId === element.localId) {
                            //如果localID相同
                            result = index;
                        } else if (item.id === element.id) {
                            //新物品，localID不同但id、規格都和原有的物品相同，就加原有物品的數量
                            let itemJson = JSON.stringify(this.copyItemForCheck(item));
                            let itemElement = JSON.stringify(this.copyItemForCheck(element));
                            if (itemJson === itemElement) {
                                result = index;
                            }
                        }

                        // if (result !== -1) {
                        //     throw BreakException;
                        // }

                    });
                } catch (e) {
                    if (e !== BreakException) throw e;
                }
            }
        }
        return result;
    },

    /** 複製一個檢查用的物件 */
    copyItemForCheck: function (item) {
        let result = {};
        if (util.notNull(item)){
            //複製物件，{}裡面可以寫要新增的屬性
            result = Object.assign({}, item);
            //把不是關鍵的屬性刪掉
            delete result.buyAmount;
            delete result.soldCount;
            delete result.localId;
            delete result.updateTime;
        }
        return result;
    },

    /** 商品轉成 Json */
    itemToJson: function (item) {
        let json = "";
        if (util.notNull(item)) {
            json = JSON.stringify(item);
        }
        return json;
    },

    /** 取得整個商圈購物車相關資料 */
    getData: function () {
        let json = sessionStorage.getItem("marketCart");
        if (json !== '') {
            let data = JSON.parse(json);
            return data;
        }
        return null;
    },

    /** 只取購物車資料 */
    getCart: function () {
        let data = this.getData();
        if (util.notNull(data)) {
            return data.cart;
        }
        return null;
    },

    /** 寫入購物車資料到 localStorage */
    saveCartToStorage: function (itemList) {
        if (util.notNull(itemList)) {
            this.saveToStorage(-1, -1, itemList);
            return true;
        }
        return false;
    },

    /** 寫入 localStorage，更新 ID */
    saveToStorage: function (nowId, nowShopAreaId, cartData) {
        //如果沒有 data
        let data = this.getData();
        if (!util.notNull(data)) {
            data = {
                nowId: 0,       //購物車物品的 ID，記錄目前 localId發到哪裏(暫時不用)
                nowShopAreaId: 0,       //目前商圈的 ID，記錄現在的商品在哪個商圈(暫時不用)
                cart: [],
            };
        }

        if (nowId > 0) {
            data.nowId = nowId;
        }
        if (nowShopAreaId > 0) {
            data.nowShopAreaId = nowShopAreaId;
        }
        if (util.notNull(cartData)) {
            data.cart = cartData;
        }

        let json = JSON.stringify(data);
        sessionStorage.setItem("marketCart", json);
        return true;
    },
}